import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getAllInspectionCategories(context) {
    return axios
      .get("inspectionCategory")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createInspectionCategory(context, value) {
    return axios
      .post("inspectionCategory", value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("inspections.category.createdMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateInspectionCategory(context, value) {
    return axios
      .put("inspectionCategory/" + value.id, value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("inspections.category.updatedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteInspectionCategory(context, value) {
    return axios
      .delete("inspectionCategory/" + value.id)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("inspections.category.deletedMessage"),
        );
        return r;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleInspectionCategory(context, id) {
    return axios
      .get("inspectionCategory/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getInspectionCategoryCounts(context) {
    return axios
      .get("inspectionCategory/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
